// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('ui/web/statementCard').name];

module.exports = angular
  .module('bench.app.dms.statements.ledger', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.statements.ledger', {
      url: '/:date/ledger/{ledgerId:[0-9]*}',
      params: {
        date: {
          value: String(new Date().getFullYear()),
        },
      },
      controller($stateParams, $state) {
        if ($stateParams.date === 'all') {
          $state.go('bench.dms.statements.ledger', angular.extend($stateParams, { date: '' }));
        }
        this.$stateParams = $stateParams;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<bl-statement-card
  client-id="vm.$stateParams.clientId"
  date="vm.$stateParams.date"
  ledger-id="vm.$stateParams.ledgerId">
</bl-statement-card>\
`,
    }),
  );
